// export const ActionTypes = {
export enum Vehicle {
    INITIALIZE_VEHICLES = 'INITIALIZE_VEHICLES',
    GET_PART_OF_VEHICLES = 'GET_PART_OF_VEHICLES',
    SET_DETAILS_FOR_VEHILE_VIEW = 'SET_DETAILS_FOR_VEHILE_VIEW',
    ADD_CAR_SUCCESS = 'ADD_CAR_SUCCESS',
    ADD_CAR_FAILURE = 'ADD_CAR_FAILURE',
    UPDATE_CAR_SUCCESS = 'UPDATE_CAR_SUCCESS',
    UPDATE_CAR_FAILURE = 'UPDATE_CAR_FAILURE',
    SET_CAR_NAME_SUCCESS = 'SET_CAR_NAME_SUCCESS',
    SET_CAR_NAME_FAILURE = 'SET_CAR_NAME_FAILURE',
    GET_SINGLE_CAR_DETAILS_SUCCESS = 'GET_SINGLE_CAR_DETAILS_SUCCESS',
    GET_SINGLE_CAR_DETAILS_FAILURE = 'GET_SINGLE_CAR_DETAILS_FAILURE',
    UPLOAD_CAR_IMAGE_SUCCESS = 'UPLOAD_CAR_IMAGE_SUCCESS',
    UPLOAD_CAR_IMAGE_FAILURE = 'UPLOAD_CAR_IMAGE_FAILURE',
    GET_SINGLE_CAR_IMAGES_SUCCESS = 'GET_SINGLE_CAR_IMAGES_SUCCESS',
    GET_SINGLE_CAR_IMAGES_FAILURE = 'GET_SINGLE_CAR_IMAGES_FAILURE',
    DELETE_CAR_IMAGE_SUCCESS = 'DELETE_CAR_IMAGE_SUCCESS',
    DELETE_CAR_IMAGE_FAILURE = 'DELETE_CAR_IMAGE_FAILURE',
    GET_FILTERED_CARS_SUCCESS = 'GET_FILTERED_CARS_SUCCESS',
    GET_CARS_NEXT_SUCCESS = 'GET_CARS_NEXT_SUCCESS',
    GET_FILTERED_CARS_FAILURE = 'GET_FILTERED_CARS_FAILURE',
    UPDATE_CAR_LATEST_DATAFRAME = 'UPDATE_CAR_LATEST_DATAFRAME',
    OPEN_SSE_DIAGNOSTIC_SUCCESS = 'OPEN_SSE_DIAGNOSTIC_SUCCESS',
    GET_TOTAL_LIST_CARS_SUCCESS = 'GET_TOTAL_LIST_CARS_SUCCESS',
    RESET_CAR_FILTERED_DATA = 'RESET_CAR_FILTERED_DATA',
    SET_TURN_OFF_CAR_DATE = 'SET_TURN_OFF_CAR_DATE',
    GET_SINGLE_CAR_ADDITIONAL_INFO = 'GET_SINGLE_CAR_ADDITIONAL_INFO',
    SAVE_SEARCH_QUERY = 'SAVE_SEARCH_QUERY',
    UPDATE_REQUEST_HAS_ERROR = 'UPDATE_REQUEST_HAS_ERROR',
    CLEAR_SEARCH_META = 'CLEAR_SEARCH_META',
    UPDATE_HAS_SEARCHED = 'UPDATE_HAS_SEARCHED',
    CACHE_SEARCHED_VEHICLES = 'CACHE_SEARCHED_VEHICLES',
    INIT_SEARCHED_VEHICLES = 'INIT_SEARCHED_VEHICLES',
    SET_IS_SEARCHING = 'SET_IS_SEARCHING',
    SAVE_SEARCHED_FILTERS = 'SAVE_SEARCHED_FILTERS',
    SAVE_FILTERS = 'SAVE_FILTERS',
    RESTORE_FILTERED_SEARCHED_VEHICLES = 'RESTORE_FILTERED_SEARCHED_VEHICLES',
    RESTORE_FILTERED_VEHICLES = 'RESTORE_FILTERED_VEHICLES',
    RESET_SUCCEED = 'RESET_SUCCEED',
    RESET_INIT = 'RESET_INIT',
    SET_BASIC_QUERY_PARAMS = 'SET_BASIC_QUERY_PARAMS'
}

export enum User {
    LOG_IN = 'LOG_IN',
    LOG_IN_SUCCESS = 'LOG_IN_SUCCESS',
    LOG_IN_FAILURE = 'LOG_IN_FAILURE',
    LOG_OUT = 'LOG_OUT',
    NO_ACTIVE_USER_FOUND = 'NO_ACTIVE_USER_FOUND',
    RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE',
    RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS',
    RESET_PASSWORD_CONFIRM_FAILURE = 'RESET_PASSWORD_CONFIRM_FAILURE',
    RESET_PASSWORD_CONFIRM_SUCCESS = 'RESET_PASSWORD_CONFIRM_SUCCESS',
    CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS',
    CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE',
    CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS',
    CREATE_USER_FAILURE = 'CREATE_USER_FAILURE',
    DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS',
    DELETE_USER_FAILURE = 'DELETE_USER_FAILURE',
    ACTIVATE_USER_SUCCESS = 'ACTIVATE_USER_SUCCESS',
    ACTIVATE_USER_FAILURE = 'ACTIVATE_USER_FAILURE',
    CLEAR_CREATE_USER_STATUS = 'CLEAR_CREATE_USER_STATUS',
    BEGIN_ACTIVATE_USER_SUCCESS = 'BEGIN_ACTIVATE_USER_SUCCESS',
    BEGIN_ACTIVATE_USER_FAILURE = 'BEGIN_ACTIVATE_USER_FAILURE',
    GET_USER_LIST_SUCCESS = 'GET_USER_LIST_SUCCESS',
    GET_USER_LIST_FAILURE = 'GET_USER_LIST_FAILURE',
    BLOCK_USER_SUCCESS = 'BLOCK_USER_SUCCESS',
    BLOCK_USER_FAILURE = 'BLOCK_USER_FAILURE',
    UNBLOCK_USER_SUCCESS = 'UNBLOCK_USER_SUCCESS',
    UNBLOCK_USER_FAILURE = 'UNBLOCK_USER_FAILURE',
    SET_ACTIVE_USER = 'SET_ACTIVE_USER',
    SET_ROLE_FILTER = 'SET_ROLE_FILTER',
    BLOCK_ACTIVE_USER = 'BLOCK_ACTIVE_USER',
    UNBLOCK_ACTIVE_USER = 'UNBLOCK_ACTIVE_USER',
    GET_USER_BY_ID_SUCCESS = 'GET_USER_BY_ID_SUCCESS',
    GET_USER_BY_ID_FAILURE = 'GET_USER_BY_ID_FAILURE',
    GET_USER_LIST_WITH_FILTERS_SUCCESS = 'GET_USER_LIST_WITH_FILTERS_SUCCESS',
    LOG_IN_SUCCESS_NOT_PERMISSION = 'LOG_IN_SUCCESS_NOT_PERMISSION',
    UPDATE_VOIVODESHIPS = 'UPDATE_VOIVODESHIPS',
    UPDATE_COUNTIES = 'UPDATE_COUNTIES',
}

export enum ViewManagement {
    TOGGLE_SIDEBAR_MENU = 'TOGGLE_SIDEBAR_MENU',
    SHOW_LOADER = 'SHOW_LOADER',
    HIDE_LOADER = 'HIDE_LOADER',
    SHOW_DETAILS_PANEL = 'SHOW_DETAILS_PANEL',
    HIDE_DETAILS_PANEL = 'HIDE_DETAILS_PANEL',
    TOGGLE_DETAILS_PANEL = 'TOGGLE_DETAILS_PANEL',
    TOGGLE_BOTTOM_TABLE = 'TOGGLE_BOTTOM_TABLE',
    SET_ACTIVE_PAGE = 'SET_ACTIVE_PAGE',
    SET_LANGUAGE = 'SET_LANGUAGE',
    SHOW_CARRIDE_DETAILS_VIEW = 'SHOW_CARRIDE_DETAILS_VIEW',
    HIDE_CARRIDE_DETAILS_VIEW = 'HIDE_CARRIDE_DETAILS_VIEW',
    SET_ACTIVE_RIDE_VIEW_TYPE = 'SET_ACTIVE_RIDE_VIEW_TYPE',
    SET_ACTIVE_ZONE_VIEW = 'SET_ACTIVE_ZONE_VIEW',
    SET_ACTIVE_CAR_DETAILS_VIEW = 'SET_ACTIVE_CAR_DETAILS_VIEW',
    TOGGLE_ADDING_AOI = 'TOGGLE_ADDING_AOI',
    SHOW_ADDING_AOI = 'SHOW_ADDING_AOI',
    HIDE_ADDING_AOI = 'HIDE_ADDING_AOI',
    SHOW_ADDING_POI = 'SHOW_ADDING_POI',
    HIDE_ADDING_POI = 'HIDE_ADDING_POI',
    SHOW_VEHICLE_LIST = 'SHOW_VEHICLE_LIST',
    HIDE_VEHICLE_LIST = 'HIDE_VEHICLE_LIST',
    SHOW_POPUP = 'SHOW_POPUP',
    HIDE_POPUP = 'HIDE_POPUP',
    SHOW_ZONES = 'SHOW_ZONES',
    MANAGE_MAP_SUMMARY = 'MANAGE_MAP_SUMMARY',
    CHANGE_ALERT_LIST_TYPE = 'CHANGE_ALERT_LIST_TYPE',
    SHOW_DETAILS_SIDEBAR_LOADER = 'SHOW_DETAILS_SIDEBAR_LOADER',
    HIDE_DETAILS_SIDEBAR_LOADER = 'HIDE_DETAILS_SIDEBAR_LOADER',
    SHOW_ALERTS = 'SHOW_ALERTS'
}

export enum Error {
    CATCH_ERR = 'CATCH_ERR',
    SHOW_ERR = 'SHOW_ERR',
    HIDE_ERR = 'HIDE_ERR'
}

export enum POI {
    GET_POI_SUCCESS = 'GET_POI_SUCCES',
    GET_POI_FAILURE = 'GET_POI_FAILURE',
    ADD_POI_SUCCESS = 'ADD_POI_SUCCESS',
    ADD_POI_FAILURE = 'ADD_POI_FAILURE',
    DELETE_POI_SUCCESS = 'DELETE_POI_SUCCESS',
    DELETE_POI_FAILURE = 'DELETE_POI_FAILURE',
    UPDATE_POI_SUCCESS = 'UPDATE_POI_SUCCESS',
    SET_DETAILS_FOR_POI_VIEW = 'SET_DETAILS_FOR_POI_VIEW',
    POI_DETAILS_POPUP_SHOW = 'POI_DETAILS_POPUP_SHOW',
    POI_DETAILS_POPUP_HIDE = 'POI_DETAILS_POPUP_HIDE',
    POI_DETAILS_POPUP_TOGGLE = 'POI_DETAILS_POPUP_TOGGLE',
    ADD_POI_POPUP_POSITION = 'ADD_POI_POPUP_POSITION'
}

export enum History {
    GET_CAR_RIDES_HISTORY_SUCCESS = '@@history/GET_CAR_RIDES_HISTORY_SUCCESS',
    GET_CAR_RIDES_HISTORY_FAILURE = '@@history/GET_CAR_RIDES_HISTORY_FAILURE',
    GET_CAR_RIDE_DETAILS_SUCCESS = '@@history/GET_CAR_RIDE_DETAILS_SUCCESS',
    GET_CAR_RIDE_DETAILS_FAILURE = '@@history/GET_CAR_RIDE_DETAILS_FAILURE',
    SET_ACTIVE_CARRIDE = '@@history/SET_ACTIVE_CARRIDE',
    GET_CAR_TODAYS_RIDE_SUCCESS = '@@history/GET_CAR_TODAYS_RIDE_SUCCESS',
    GET_CAR_TODAYS_RIDE_FAILURE = '@@history/GET_CAR_TODAYS_RIDE_FAILURE',
    GET_LATEST_DATAFRAMES_SUCCESS = '@@history/GET_LATEST_DATAFRAMES_SUCCESS',
    GET_LATEST_DATAFRAMES_FAILURE = '@@history/GET_LATEST_DATAFRAMES_FAILURE',
    SET_ACTIVE_DATAFRAME = '@@history/SET_ACTIVE_DATAFRAME',
    CLEAR_RIDE_DETAILS = '@@history/CLEAR_RIDE_DETAILS',
    CLEAR_HISTORY_RIDES_SUBMISSION = '@@history/CLEAR_HISTORY_RIDES_SUBMISSION',
    CLEAR_HISTORY_RIDES = '@@history/CLEAR_HISTORY_RIDES',
    SAVE_RIDE_LIST_INDEX = '@@history/SAVE_RIDE_LIST_INDEX',
    SAVE_LATEST_DATAFRAMES_QUERY = '@@history/SAVE_LAST_DATAFRAMES_QUERY',
    TOGGLE_LATEST_DATAFRAMES_MANUAL_HANDLING = '@@history/TOGGLE_LATEST_DATAFRAMES_MANUAL_HANDLING'
}

export enum AOI {
    GET_AOI_LIST_SUCCESS = 'GET_AOI_LIST_SUCCESS',
    GET_AOI_LIST_FAILURE = 'GET_AOI_LIST_FAILURE',
    ADD_AOI_SUCCESS = 'ADD_AOI_SUCCESS',
    ADD_AOI_FAILURE = 'ADD_AOI_FAILURE',
    DELETE_AOI_SUCCESS = 'DELETE_AOI_SUCCESS',
    DELETE_AOI_FAILURE = 'DELETE_AOI_FAILURE',
    SET_DETAILS_FOR_AOI_VIEW = 'SET_DETAILS_FOR_AOI_VIEW',
    AOI_DETAILS_POPUP_SHOW = 'AOI_DETAILS_POPUP_SHOW',
    AOI_DETAILS_POPUP_HIDE = 'AOI_DETAILS_POPUP_HIDE',
    ADD_COORDS_TO_NEW_ZONE = 'ADD_COORDS_TO_NEW_ZONE',
    CLEAR_COORDS_OF_NEW_ZONE = 'CLEAR_COORDS_OF_NEW_ZONE',
    UPDATE_AOI_SUCCESS = 'UPDATE_AOI_SUCCESS'
}

export enum ERORR {
    CLEAR_ERRORS = 'CLEAR_ERRORS',
    SET_RQ_CONFIG = 'SET_RQ_CONFIG',
    SET_RQ_RESPONSE_ERR = 'SET_RQ_RESPONSE_ERR',
    SET_SSE_RQ_RESPONSE_ERR = 'SET_SSE_RQ_RESPONSE_ERR',
    RESPONSE_SUCCESS = 'RESPONSE_SUCCESS',
    SET_NEWS = 'SET_NEWS',
    UNAUTHORIZED_USER = 'UNAUTHORIZED_USER'
}

export enum MAP {
    SET_ZOOM = '@@map/SET_ZOOM',
    SET_CENTER = '@@map/SET_CENTER',
    MANAGE_ZOOM = '@@map/MANAGE_ZOOM',
    SMALL_MAP_SET_ZOOM = '@@map/SMALL_MAP_SET_ZOOM',
    SMALL_MAP_SET_CENTER = '@@map/SMALL_MAP_SET_CENTER',
    SMALL_MAP_MANAGE_ZOOM = '@@map/SMALL_MAP_MANAGE_ZOOM',
    SET_SMALL_MAP_REF = '@@map/SET_SMALL_MAP_REF',
    SET_MAP_REF = '@@map/SET_MAP_REF',
    SET_SMALL_MAP_LATEST_BOUNDS = '@@map/SET_SMALL_MAP_LATEST_BOUNDS',
    SET_MAP_LATEST_BOUNDS = '@@map/SET_MAP_LATEST_BOUNDS'
}

export enum FLEET {
    UPDATE_FLEET_CARS = 'UPDATE_FLEET_CARS',
    DELETE_FLEET = 'DELETE_FLEET',
    DELETE_CAR_FROM_FLEET = 'DELETE_CAR_FROM_FLEET',
    GET_USER_FLEET = 'GET_USER_FLEET',
    CREATE_FLEET = 'CREATE_FLEET',
    MANAGE_FLEET_CARS = 'MANAGE_FLEET_CARS',
    SET_ACTIVE_FLEET = 'SET_ACTIVE_FLEET',
    RESET_FLEET_CARS = 'RESET_FLEET_CARS',
    GET_FLEET_BY_ID = 'GET_FLEET_BY_ID',
    GET_USER_FLEET_FILTERED = 'GET_USER_FLEET_FILTERED',
    RESET_FLEET_FILTERED_DATA = 'RESET_FLEET_FILTERED_DATA',
    SET_ACTIVE_ROW_ID = 'SET_ACTIVE_ROW_ID',
    CACHE_FORM_VALUES = 'CACHE_FORM_VALUES',
    SET_PARAMS = 'SET_PARAMS'
}

export enum ALERT {
    UPDATE_ALERT = 'UPDATE_ALERT',
    DELETE_ALERT = 'DELETE_ALERT',
    GET_USER_ALERTS = 'GET_USER_ALERTS',
    CREATE_ALERT = 'CREATE_ALERT',
    SET_ACTIVE_ALERT = 'SET_ACTIVE_ALERT',
    SET_ACTIVE_HISTORY_ALERT = 'SET_ACTIVE_HISTORY_ALERT',
    GET_ALERT_BY_ID = 'GET_ALERT_BY_ID',
    MANAGE_CARS = 'MANAGE_CARS',
    MANAGE_FLEETS = 'MANAGE_FLEETS',
    MANAGE_DOMAIN_OF_INTREST = 'MANAGE_DOMAIN_OF_INTREST',
    ENABLING_ALERT = 'ENABLING_ALERT',
    GET_HISTORY_LOG = 'GET_HISTORY_LOG',
    CLEAR_HISTORY_LOG = 'CLEAR_HISTORY_LOG',
    ENABLE_ALERT = 'ENABLE_ALERT',
    DISABLE_ALERT = 'DISABLE_ALERT'
}

export enum NOTIFICATION {
    GET_NOTIFICATIONS = 'GET_NOTIFICATIONS',
    READ_NOTIFICATION = 'READ_NOTIFICATION',
    OPEN_SSE_NOTIFICATION = 'OPEN_SSE_NOTIFICATION',
    ADD_NEW_NOTIFICATION = 'ADD_NEW_NOTIFICATION',
    UPDATE_PARAMS = 'UPDATE_PARAMS',
    SET_ACTIVE_NOTIFICATION = 'SET_ACTIVE_NOTIFICATION',
    CLEAR_NOTIFICATIONS = 'CLEAR_NOTIFICATIONS'
}

export enum REPORT {
    GET_CAR_MAIN_REPORT = 'GET_CAR_MAIN_REPORT',
    GET_TERMINAL_INSTALLATION_REPORT = 'GET_TERMINAL_INSTALLATION_REPORT',
    GET_ACTIVE_TERMINALS_REPORT = 'GET_ACTIVE_TERMINALS_REPORT',
    GET_VEHICLES_STATE_REPORT = 'GET_VEHICLES_STATE_REPORT',
    GET_CAR_PARKING_REPORT = 'GET_CAR_PARKING_REPORT',
    GET_REPORT_FILE = 'GET_REPORT_FILE',
    GET_CAR_RIDES_REPORT = 'GET_CAR_RIDES_REPORT'
}

export enum CONTRACT {
    GET_CONTRACT_LIST_SUCCESS = 'GET_CONTRACT_LIST_SUCCESS',
    GET_CONTRACT_LIST_WITH_FILTERS_SUCCESS = 'GET_CONTRACT_LIST_WITH_FILTERS_SUCCESS',
    GET_CONTRACT_HISTORY_SUCCESS = 'GET_CONTRACT_HISTORY_SUCCESS',
    SET_ACTIVE = 'SET_ACTIVE',
    SET_CURRENT_CONTRACT_VIN = 'SET_CURRENT_CONTRACT_VIN',
}

export enum TerminalInstallation {
    CREATE_TERMINAL_INSTALLATION_ORDER = '@@TERMINAL_INSTALLATION_ORDER/CREATE_TERMINAL_INSTALLATION_ORDER',
    GET_TERMINAL_INSTALLATION_ORDER_SUCCESS = '@@TERMINAL_INSTALLATION_ORDER/GET_TERMINAL_INSTALLATION_ORDER_SUCCESS',
    GET_TERMINAL_INSTALLATION_ORDER_WITH_FILTERS_SUCCESS = '@@TERMINAL_INSTALLATION_ORDER/GET_TERMINAL_INSTALLATION_ORDER_WITH_FILTERS_SUCCESS',
    GET_TERMINAL_INSTALLATION_TOTAL_COUNT_SUCCESS = '@@TERMINAL_INSTALLATION_ORDER/GET_TERMINAL_INSTALLATION_TOTAL_COUNT_SUCCESS',
    GET_TERMINAL_INSTALLATION_ORDER_FAILURE = '@@TERMINAL_INSTALLATION_ORDER/GET_TERMINAL_INSTALLATION_ORDER_FAILURE',
    //CREATE_TERMINAL_INSTALLATION_ORDER_SUCCES = '@@TERMINAL_INSTALLATION_ORDER/CREATE_TERMINAL_INSTALLATION_ORDER_SUCCES',
    //CREATE_TERMINAL_INSTALLATION_ORDER_FAILURE = '@@TERMINAL_INSTALLATION_ORDER/CREATE_TERMINAL_INSTALLATION_ORDER_FAILURE',
    //GET_TERMINALL_INSTALATION_BY_ID_SUCCES = '@@TERMINAL_INSTALLATION_ORDER/GET_TERMINALL_INSTALATION_BY_ID_SUCCES',
    //GET_TERMINALL_INSTALATION_BY_ID_SUCCES = '@@TERMINAL_INSTALLATION_ORDER/GET_TERMINALL_INSTALATION_BY_ID_FAILURE',
    SET_TERMINAL_INSTALLATION_ONE_ELEMENT = '@@TERMINAL_INSTALLATION_ORDER/SET_TERMINAL_INSTALLATION_ONE_ELEMENT',
    SET_ACTIVE = '@@TERMINAL_INSTALLATION_ORDER/SET_ACTIVE',
    SET_TECHNICIAN_LIST = '@@TERMINAL_INSTALLATION_ORDER/SET_TECHNICIAN_LIST',
    SET_HISTORY_SUCCESS = '@@TERMINAL_INSTALLATION_ORDER/SET_HISTORY_SUCCESS',
    SET_HISTORY_ERROR = '@@TERMINAL_INSTALLATION_ORDER/SET_HISTORY_ERROR',
    SET_HISTORY_COMMENTS = '@@TERMINAL_INSTALLATION_ORDER/SET_HISTORY_COMMENTS',
    SET_STATUS_HISTORY_LOADER = '@@TERMINAL_INSTALLATION_ORDER/SET_STATUS_HISTORY_LOADER',
    SET_TERMINAL_NOTES_LIST = '@@SET_TERMINAL_NOTES_LIST',
    UPDATE_TERMINAL_NOTES_LIST = '@@UPDATE_TERMINAL_NOTES_LIST'
}

export enum Collision {
    SET_COLLISION_DATAFRAMES = '@@HISTORY_COLLISION/SET_COLLISION_DATAFRAMES',
    SET_ACTIVE_DATA_FRAMES = '@@HISTORY_COLLISION/SET_ACTIVE_DATA_FRAMES',
    SET_COLLISIONS_LIST = '@@HISTORY_COLLISION/SET_COLLISIONS_LIST',
    SET_ACTIVE_COLLISION = '@@HISTORY_COLLISION/SET_ACTIVE_COLLISION',
    SET_COLLISION_TOKEN = '@@HISTORY_COLLISION/SET_COLLISION_TOKEN'
}

export enum InfinityTable {
    SET_LOADING = "@@INFINITY_TABLE_SET_LOADING",
    SET_COUNT = "@@INFINITY_TABLE_SET_COUNT",
    SET_TOTAL_COUNT = "@@INFINITY_TABLE_SET_TOTAL_COUNT",
    SET_ALL_COUNTS = "@@INFINITY_TABLE_SET_ALL_COUNTS"
}

// }



// WEBPACK FOOTER //
// ./src/Redux/Actions/EnumTypes/ActionEnumTypes.ts